'use client';
import Card from '@/components/next-ui/Card';
import FadeTransition from '@/components/next-ui/Transitions/FadeTransition';
import Typography from '@/components/next-ui/Typography';
import { Disclosure } from '@headlessui/react';
import React from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';

function CollapsibleCard(props) {
  const { title, collapsed = false, children } = props;

  return (
    <Card className="gap-6">
      <Disclosure defaultOpen={!collapsed}>
        {({ open }) => (
          <>
            <Disclosure.Button className="flex w-full items-center justify-between">
              <div className="flex items-center justify-start gap-4">
                <Typography variant="h3">{title}</Typography>
              </div>
              <MdOutlineKeyboardArrowDown
                className={`${
                  open ? 'rotate-180 transform' : ''
                } h-5 w-5 text-text-secondary`}
              />
            </Disclosure.Button>
            <FadeTransition>
              <Disclosure.Panel className="flex flex-col gap-4">
                {children}
              </Disclosure.Panel>
            </FadeTransition>
          </>
        )}
      </Disclosure>
    </Card>
  );
}

export default CollapsibleCard;
